import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'callback',
    pure: false
})
export class CallbackPipe implements PipeTransform {
    transform(items: any[], arg1: any): any {
        if (!items) {
            return items;
        }
        return items.filter(i => i.id_agrupador == arg1);
    }
}